import Util from './util';

import { jquery } from 'jquery';
import $ from 'jquery';

export default class TapAnimation {
    constructor() {
        this.init();
    }

    init() {
        
        this.setEvent();
    }

    setEvent() {
        let self_ = this;

        if ('ontouchstart' in window) {
                document.body.addEventListener('touchstart', function (event) {

                let pageX_ = 0;
                let pageY_ = 0;
                pageX_ = event.touches[0].pageX !== undefined ? Math.floor(event.touches[0].pageX) : 0;
                pageY_ = event.touches[0].pageY !== undefined ? Math.floor(event.touches[0].pageY) : 0;

                self_.animation(pageX_, pageY_);

            });
        } else {
            document.body.addEventListener('click', function (event) {
                
                let pageX_ = 0;
                let pageY_ = 0;

                pageX_ = event.pageX !== undefined ? Math.floor(event.pageX) : 0;
                pageY_ = event.pageY !== undefined ? Math.floor(event.pageY) : 0;

                self_.animation(pageX_, pageY_);
            });
        }
    }

    animation(x, y) {
        let taplight = document.createElement('div');
        taplight.className = 'c-tap';
        taplight.style = 'transform: translate(' + x + 'px, ' + y + 'px);';

        document.getElementById('main').appendChild(taplight);

        Util.wait(900).then(
            function () {
                document.getElementById('main').removeChild(taplight);
            },
            function () {}
        );
    }
}
